/* eslint-disable */
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail, ArrowLeft, Send } from 'lucide-react';
import axiosClient from '../api/axiosClient';
import toast from 'react-hot-toast';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [resetToken, setResetToken] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axiosClient.post('/auth/forgot-password', { email });
      if (res.data.resetToken) {
        setResetToken(res.data.resetToken);
      }
      toast.success('Password reset token generated.');
    } catch (err) {
      toast.error('Failed to generate reset link.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-950 px-4 font-sans">
      <div className="w-full max-w-md bg-slate-900 border border-slate-800 p-8 rounded-3xl shadow-2xl space-y-6">
        <Link to="/admin/login" className="inline-flex items-center space-x-2 text-xs text-slate-400 hover:text-white">
          <ArrowLeft size={14} />
          <span>Back to Login</span>
        </Link>

        <div>
          <h2 className="text-xl font-bold text-white">Reset Admin Password</h2>
          <p className="text-xs text-slate-400 mt-1">Enter your registered email address to receive password recovery instructions.</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-xs font-bold text-slate-400 mb-1">Email Address</label>
            <div className="relative">
              <Mail className="absolute left-3.5 top-3.5 h-4 w-4 text-slate-500" />
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="admin@fajtech.com"
                className="w-full pl-10 pr-4 py-3 rounded-xl border border-slate-800 bg-slate-950 text-white text-sm focus:ring-2 focus:ring-blue-500"
              />
            </div>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full py-3 rounded-xl font-bold text-sm bg-blue-600 hover:bg-blue-500 text-white flex items-center justify-center space-x-2"
          >
            <Send size={16} />
            <span>{loading ? 'Sending...' : 'Send Reset Link'}</span>
          </button>
        </form>

        {resetToken && (
          <div className="p-4 rounded-xl bg-blue-500/10 border border-blue-500/30 text-xs text-blue-300 space-y-2">
            <p className="font-bold">Demo Reset Token Generated:</p>
            <p className="font-mono break-all text-[11px] bg-slate-950 p-2 rounded-lg border border-slate-800 text-white">
              {resetToken}
            </p>
            <Link
              to={`/admin/reset-password?token=${resetToken}`}
              className="inline-block font-bold text-blue-400 hover:underline pt-1"
            >
              Click here to set new password →
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}
